import store from "fragments/vendors/store"
import { gql } from "graphql-tag"

const ADD_STORE = gql`
  ${store}

  mutation addStore($storeAddInput: StoreAddInput!) {
    addStore(storeAddInput: $storeAddInput) {
      ...Store
    }
  }
`

export default ADD_STORE
